var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as gmailAnalyticsData } from '@web/lib/demo/data/gmailAnalytics';
import { filterData, getUsers } from '@web/lib/demo/utils';
import { processGmailAnalytic } from '@workalizer/shared/services/processGmailAnalytic';
export var gmailAnalytic = function (input) {
    var users = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var gmailAnalytics = filterData(gmailAnalyticsData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'userId',
            value: users.map(function (user) { return user.id; }),
            operator: 'in'
        }
    ]).map(function (item) { return (__assign(__assign({}, item), { date: new Date(item.date) })); });
    return processGmailAnalytic(gmailAnalytics, input.dateFrom, input.dateTo);
};
